import type { ContentType } from "@pdfking/pdfengine"
import { BlobToUint8, GuidToString, UInt8Hash } from "@pdfking/tfunc"
import { CreateRemoteFile } from "@pdfking/workflow/actions/pdfengine/Functions"
import create_blob from "@pdfking/workflow/utils/create_blob"

import type { FileObject } from "../types/FileObject"
import new_file_from_virtualfile from "./new_file_from_virtualfile"

// here we are creating a file from blob, we are doing this because
// caches quotas might be exceeded when uploading large files
// so we are bypassing quotas and storing the object in a blob url, obviously this file is transient
// to be improved.

export default async (transfer: File): Promise<FileObject> =>
  new_file_from_virtualfile({
    path: transfer.name,
    file: await CreateRemoteFile({
      mirrors: [create_blob(transfer as unknown as Uint8Array, transfer.type)],
      type: transfer.type as ContentType,
      guid: await UInt8Hash([await BlobToUint8(transfer)]).then(GuidToString),
    }),
  })
